// extracted by mini-css-extract-plugin
export var wrapper = "countdown-timer-module--wrapper--4hT0Z";